/**
 * ArtifactKindIcon — the colored square for an artifact kind. Demo page: /file-manager (file type tile).
 * Unknown kinds fall back to custom.
 */
import React from 'react';
import { getKindConfig } from '../artifact-detail/kind-config.js';

interface ArtifactKindIconProps {
  kind: string;
  size?: 'sm' | 'md';
}

export const ArtifactKindIcon: React.FC<ArtifactKindIconProps> = ({ kind, size = 'md' }) => {
  const { squareBg, squareText, icon: Icon, badgeLabel } = getKindConfig(kind);
  const dim = size === 'sm' ? 'size-[22px] rounded-md' : 'size-[34px] rounded-lg';
  return (
    <span className={`inline-grid shrink-0 place-items-center ${dim} ${squareBg} ${squareText}`} title={badgeLabel}>
      <Icon size={size === 'sm' ? 12 : 16} aria-hidden="true" />
    </span>
  );
};
